import {createStore} from 'redux';
import {fromJS, Map} from 'immutable';
import {applyMiddleware} from 'redux';
import ReduxThunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';

const makeStore = (reducers = {}, INITIAL_STATE = Map({})) => {
    const middleware = [ReduxThunk];
    const composeEnhancers = composeWithDevTools({
        name: 'Peak Retreats Redux store'
    });
    return createStore(reducers, INITIAL_STATE, composeEnhancers(
        applyMiddleware(...middleware)
    ));
};

export default makeStore;
